import {
	TRIGGER_TOUR_GUIDE_MODAL,
	TOUR_GUIDE_SCROLL_STEPS_INCREASE,
	TOUR_GUIDE_SCROLL_STEPS_DECREASE,
	RESET_SCROLL_STEPS,
	RESTART_TOUR_GUIDE,
} from '../constants/tourGuideConstants';

export const tourGuideReducer = (
	state = { triggerTourGuideModal: false, restartTourGuide:false },
	action
) => {
	switch (action.type) {
		case TRIGGER_TOUR_GUIDE_MODAL:
			return {
				...state,
				triggerTourGuideModal: action.payload,
			};
		case RESTART_TOUR_GUIDE:
			return {
				...state,
				restartTourGuide:action.payload,
			}
		default:
			return state;
	}
};

export const tourGuideStepReducer = (
	state = { scrollToTop:false ,tourStep: -1 },
	action
) => {
	switch (action.type) {
		case TOUR_GUIDE_SCROLL_STEPS_INCREASE:
			return {
				...state,
				tourStep: state.tourStep + 1,
			};
		case TOUR_GUIDE_SCROLL_STEPS_DECREASE:
			return {
				...state,
				tourStep: state.tourStep === 8 ? 7 : state.tourStep - 1,
			};
		case RESET_SCROLL_STEPS:
			return{
				...state,
				tourStep: action.payload,
			}
		default:
			return state;
	}
};
